import React from "react";
import { BsDot } from "../utils/Icons";

// Imports
import TitleText from "./TitleText";

const TrustedBy = () => {
  return (
    <div className="w-full h-fit flex flex-col justify-center items-start  px-[3%] lg:px-[2%] py-[7.5%] lg:py-[5%] space-y-[5%] lg:space-y-0">
      <div className="w-full h-fit space-y-[5%] lg:space-y-[3%]">
        <div className="flex flex-col justify-start items-start">
          <h1 className="font-normal text-[3.5vw] lg:text-[0.9vw] text-textPrimaryColor">
            Trusted by Millions
          </h1>
          <TitleText text="Medical Lab Testing & Diagnosis Centres in India" />
        </div>
        <div className="w-full h-fit flex flex-col lg:flex-row justify-center items-start lg:items-start">
            <img src="/assets/map.svg" alt="map" className="lg:w-[70%] lg:h-[70%] lg:mr-[10%]"/>
            <div className="w-full h-fit grid grid-cols-1 lg:grid-cols-2 gap-y-5 lg:gap-y-10 gap-x-2 mt-[4%] lg:mt-0">
            <div className="w-full h-fit flex flex-col justify-start items-start space-y-[1%] lg:space-y-[2%]">
            <div className="font-semibold text-[16px]">Nationwide Home Collection</div>
            <div className="w-full h-fit flex flex-wrap justify-start items-start space-x-1.5">
            <h1 className="lg:w-[60%] w-full font-light text-[15px] text-[#57636C]">
            We provide medical lab testing   with home collection services  
            all over India,  Ensuring free and   timely delivery.
            </h1>
          </div>
             </div>
          <div className="w-full h-fit flex flex-col justify-start items-start space-y-[1%] lg:space-y-[2%]">
             <div className="font-semibold text-[16px]">Trusted Lab Partners</div>
            <div className="w-full h-fit flex justify-start items-start space-x-1.5">
              <h1 className="lg:w-[60%] w-full font-light text-[15px] text-[#57636C]">
              Partnered with India’s top diagnosis   centres, including Dr Lal PathLabs  
              Agilus Diagnostics, Pathkind Labs,  Redcliffe Labs, and Metropolis  
              Healthcare.
            </h1>
            </div>
          </div>
          <div className="w-full h-fit flex flex-col justify-start items-start space-y-[1%] lg:space-y-[2%]">
             <div className="font-semibold text-[16px]">Affordable Pricing</div>
            <div className="w-full h-fit flex justify-start items-start space-x-1.5">
              <h1 className="lg:w-[60%] w-full font-light text-[15px] text-[#57636C]">
              We ensure transparency on   discounts and prices, offering  
               genuine discounts and affordable  rates for every
               lab test in India
            </h1>
            </div>
          </div>
           <div className="w-full h-fit flex flex-col justify-start items-start space-y-[1%] lg:space-y-[2%]">
             <div className="font-semibold text-[16px]">Reliable & Accessible Services</div>
            <div className="w-full h-fit flex justify-start items-start space-x-1.5">
              <h1 className="lg:w-[60%] w-full font-light text-[15px] text-[#57636C]">
              Access a wide range 15,000+ of   diagnostic tests from the comfort   of your home with trusted and   timely results.
            </h1>
            </div>
          </div>
            </div>
        </div>
      </div>
    </div>
  );
};

export default TrustedBy;
